import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import type { AssessmentTemplate } from '@/api/types/assessment.types';

type LifecycleNextState = 'disabled' | 'published' | 'archived';

export function useTemplateLifecycle(tenantId: string) {
  const queryClient = useQueryClient();

  return useMutation<AssessmentTemplate, Error, { templateId: string; next_state: LifecycleNextState }>({
    mutationFn: async ({ templateId, next_state }) => {
      const { data } = await apiClient.patch<{ data: AssessmentTemplate }>(
        `/assessment-templates/${templateId}/lifecycle`,
        { next_state },
      );
      return data.data;
    },
    onSuccess: (_data, { templateId }) => {
      queryClient.invalidateQueries({ queryKey: ['assessment-templates', tenantId] });
      queryClient.invalidateQueries({ queryKey: ['assessment-template', templateId] });
    },
  });
}
